import QueryParamService from '@root/attribution/src/services/query-param-service';

export default class AppsflyerQueryParamService extends QueryParamService {
  static KEY = 'core.appsflyer';

  static PARAMETERS = [
    'pid',
    'c',
    'af_prt',
    'af_mp',
    'clickid',
    'af_siteid',
    'af_sub_siteid',
    'af_c_id',
    'af_adset',
    'af_adset_id',
    'af_ad',
    'af_ad_id',
    'af_ad_type',
    'af_click_lookback',
    'af_viewthrough_lookback',
    'is_retargeting',
    'af_reengagement_window',
    'af_channel',
    'af_keywords',
    'af_cost_model',
    'af_cost_currency',
    'af_cost_value',
    'af_sub1',
    'af_sub2',
    'af_sub3',
    'af_sub4',
    'af_sub5',
    'af_r',
    'af_web_dp',
    'af_dp',
    'af_ios_fallback',
    'af_ref',
    'is_incentivized',
    'advertising_id',
    'sha1_advertising_id',
    'android_id',
    'sha1_android_id',
    'af_android_url',
    'sha1_el',
    'fire_advertising_id',
    'idfa',
    'af_ios_url',
    'sha1_idfa',
    'mac',
    'sha1_mac',
  ];
}
